import { type GrpcObject, loadPackageDefinition } from "@grpc/grpc-js";
import { fromJSON, type Options as ProtoLoaderOptions } from "@grpc/proto-loader";
import { parse, Root } from "protobufjs";

const PROTO_OPTIONS: ProtoLoaderOptions = {
    keepCase: true,
    longs: String,
    enums: String,
    defaults: true,
    oneofs: true,
};

export function loadProtoFromString(source: string): GrpcObject {
    const bootstrapRoot = new Root();

    const { root } = parse(source, bootstrapRoot);
    const packageDef = fromJSON(root.toJSON(), PROTO_OPTIONS);
    return loadPackageDefinition(packageDef);
}
